namespace TabAurous.Retail {
    export namespace AddressSelectForPickUpService {
        export const baseUrl = 'Retail/AddressSelectForPickUp';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<POSOrderAddressRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Retail/AddressSelectForPickUp/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>AddressSelectForPickUpService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
